import { checkHttpResponseStatus } from '../../libs/util';

import { ajaxUrl } from '../config';

import validateForm from './validateForm';
import UiHelper from './UiHelper';


class FormFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes('.js-form')).forEach(form =>
        {
            new Form(form);
        });
    }
}
export default FormFactory;


export class Form
{
    constructor(form, args={})
    {
        this.doSubmit = this.doSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleError = this.handleError.bind(this);

        this.form = form;
        this.args = {
            onSubmit: this.onSubmit,
            loadingClass: 'form--loading',
            handleResponse: this.handleResponse,
            handleError: this.handleError,
            ...args
        };

        this.feedbackMsg = this.form.querySelector('.js-form__feedback-msg');

        this.form.addEventListener('submit', e =>
        {
            e.preventDefault();

            if (validateForm(this.form))
            {
                this.doSubmit();
            }
        });
    }


    doSubmit()
    {
        if (this.args.onSubmit) this.args.onSubmit();

        fetch(ajaxUrl, {
            method: 'POST',
            body: new FormData(this.form)
        })
            .then(checkHttpResponseStatus)
            .then(response => response.json())
            .then(response => this.args.handleResponse(response, this.form))
            .catch(error => this.args.handleError(error));
    }

        onSubmit()
        {
            this.form.classList.add(this.args.loadingClass);
        }

        handleResponse(response, form)
        {
            this.form.classList.remove(this.args.loadingClass);

            if (response.success)
            {
                //this.feedbackMsg.classList.add('form__feedback-msg--success');
                this.form.reset();
            }
            else
            {
                this.feedbackMsg.classList.add('form__feedback-msg--error');
            }

            this.feedbackMsg.innerHTML = `<p>${response.message}</p><button class="btn theme-bgclr-1" type="button">${window.labels.close}</button>`;

            this.form.classList.add('form--feedback');

            this.feedbackMsg.querySelector('.btn').addEventListener('click', e =>
            {
                this.feedbackMsg.classList.remove('form__feedback-msg--success');
                this.feedbackMsg.classList.remove('form__feedback-msg--error');
                this.form.classList.remove('form--feedback');
            });
        }

        handleError(error)
        {
            this.form.classList.remove(this.args.loadingClass);
            alert(error.message);
        }
}
